<template>
  <v-row>
    <v-col cols="12">
      <template v-if="isGenerated">
        <v-card outlined>
          <v-card-text>
            <h1><v-icon>mdi-chart-bar</v-icon> Sale Report</h1>
            <v-row class="mt-5 ">
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <v-select
                  v-model="form.duration"
                  :items="durations"
                  outlined
                  item-text="name"
                  item-value="value"
                  label="Duration"
                  dense
                />
              </v-col>

              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <v-select
                  v-model="form.way"
                  :items="methods"
                  item-text="name"
                  item-value="value"
                  outlined
                  label="Method"
                  dense
                />
              </v-col>
              <template v-if="form.duration === 'period'">
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="form.fromDate"
                    hide-details="auto"
                    label="Start Date"
                    outlined
                    dense
                    type="date"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="form.endDate"
                    hide-details="auto"
                    label="End Date"
                    outlined
                    type="date"
                    dense
                  />
                </v-col>
              </template>
              <v-col
                cols="12"
                md="4"
                sm="12"
                class="pl-3"
              >
                <v-btn
                  class="success"
                  @click="generateReport"
                >
                  Generate
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
      <template v-else>
        <div class="d-print-none text-right">
          <v-btn
            icon
            class="info--text"
            @click="printSaleReport"
          >
            <v-icon>mdi-printer</v-icon>
          </v-btn>
          <v-btn
            icon
            class="warning--text"
            @click="clear"
          >
            <v-icon>mdi-minus-circle-outline</v-icon>
          </v-btn>
        </div>
        <div class="pb-0">
          <h3>
            SALE REPORT : ( Duration: {{ form.duration | uppercase }}
            <template v-if="form.duration == 'period'">
              {{ form.fromDate }} to {{ form.endDate }}
            </template>
            )
          </h3>
          <h4>Generated At : {{ reference.time }}</h4>
          <h4>Generated By : {{ reference.by }}</h4>
          <img
            :src="reference.barcode"
            class="white pa-1"
          >
        </div>
        <bar-chart
          height="160px"
          width="70%"
          :data="chart"
          class="white pa-1"
          colors="black"
        />
        <table class="table">
          <thead>
            <tr>
              <th class="text-left">
                Orders
              </th>
              <th class="text-left">
                Items Sold
              </th>
              <th class="text-left">
                Total Sales
              </th>
              <th class="text-left">
                Total Cost
              </th>
              <th class="text-left">
                Total Profit
              </th>
              <th class="text-left">
                Total Tax
              </th>
              <th class="text-left">
                Total Discount
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="active">
              <td>{{ saleReport.orders }}</td>
              <td>{{ saleReport.sold }}</td>
              <td>{{ saleReport.sales | currency }}</td>
              <td>{{ saleReport.cost | currency }}</td>
              <td>{{ saleReport.profit | currency }}</td>
              <td>{{ saleReport.tax | currency }}</td>
              <td>{{ saleReport.discount | currency }}</td>
            </tr>
          </tbody>
        </table>
        <table class="table">
          <thead>
            <tr>
              <th class="text-left">
                TRX #
              </th>
              <th class="text-left">
                Sold Items
              </th>
              <th class="text-left">
                Net Cost
              </th>
              <th class="text-left">
                Net Price
              </th>
              <th class="text-left">
                Discount
              </th>
              <th class="text-left">
                Tax
              </th>
              <th class="text-left">
                Profit
              </th>
              <th class="text-left">
                Total Amount
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="sale in saleReport.list"
              :key="sale.id"
            >
              <td>
                <img
                  :src="sale.barcode"
                  class="saleBarcode white pa-1"
                >
              </td>
              <td>{{ sale.totalItems }}</td>
              <td>{{ sale.cost | currency }}</td>
              <td>{{ sale.price | currency }}</td>
              <td>{{ sale.discountedAmount | currency }}</td>
              <td>{{ sale.taxAmount | currency }}</td>
              <td>{{ sale.profit | currency }}</td>
              <td>{{ sale.totalAmount | currency }}</td>
            </tr>
          </tbody>
        </table>
      </template>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      isGenerated: true,
      durations: [
        { name: "Today's Sales", value: "today" },
        { name: "This Month Sales", value: "monthly" },
        { name: "This Year Sales ", value: "yearly" },
        { name: "Specified Period", value: "period" },
      ],
      methods: [
        { name: "Live", value: 1 },
        { name: "Due", value: 0 },
      ],
      form: {
        way: 1,
        duration: "today",
        date: "",
      },
      saleReport: {},
      reference: {},
    };
  },
  computed: {
    chart() {
      const report = this.$data.saleReport;
      return [
        ["Sale", report.sales],
        ["Cost", report.cost],
        ["Profit", report.profit],
        ["Sold", report.sold],
        ["Tax", report.tax],
      ];
    },
  },
  methods: {
    clear() {
      Event.$emit("showDrawer");
      this.$data.isGenerated = true;
    },
    printSaleReport() {
      Event.$emit("hideDrawer");
      setTimeout(() => {
        window.print();
      }, 500);
    },
    generateReport() {
      window.axios.post("/sale-report", this.form).then((response) => {
        this.$data.saleReport = response.data;
        this.$data.reference = response.data.ref;
        this.$data.isGenerated = false;
      });
    },
  },
};
</script>

<style type="text/css">
.saleBarcode {
  width: 150px;
  height: 20px;
}
</style>
